;
var sprite = require("/tmp/build_28b142ae/node_modules/svg-sprite-loader/lib/web/global-sprite");;
var image = "<symbol viewBox=\"0 0 100 100\" id=\"Vitra_Down_558615322d54e9208eaa79bbf0dcc686\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"> <g> <path d=\"M16.186,34.576l3.015-3.014l30.846,30.844l30.749-30.749l3.017,3.017L50.047,68.438L16.186,34.576z\"/> </g> </symbol>";
module.exports = sprite.add(image, "Vitra_Down_558615322d54e9208eaa79bbf0dcc686");


//////////////////
// WEBPACK FOOTER
// ./images/icons/Vitra_Down.svg
// module id = 1406
// module chunks = 0